import { useQuery } from "@tanstack/react-query";

import { PageTenantRead, TenantListRequest, TenantRead, getRanaApiV1 } from "@nens/rana/api-v1";

const TENANT_PAGE_SIZE = 100;

type TenantListPageFetcher = (
  request: Pick<TenantListRequest, "limit" | "offset" | "userId">
) => Promise<PageTenantRead>;

export async function fetchAllTenantPages(
  tenantList: TenantListPageFetcher,
  userId: string
): Promise<TenantRead[]> {
  const tenants: TenantRead[] = [];
  let offset = 0;

  while (true) {
    const page = await tenantList({ limit: TENANT_PAGE_SIZE, offset, userId });
    tenants.push(...page.items);

    if (page.items.length === 0 || tenants.length >= page.total) break;
    offset += page.items.length;
  }

  return tenants;
}

const getTenantListQuery = (userId: string) => {
  const ranaApi = getRanaApiV1();

  return ranaApi.getQueryOptions({
    ignoreTenant: true,
    queryKey: ["tenant", "list", { userId }],
    queryFn: async () => ({
      items: await fetchAllTenantPages(ranaApi.TenantsApi.tenantList, userId),
    }),
  });
};

export const useTenantListQuery = (userId: string) => useQuery(getTenantListQuery(userId));
